import { GetterTree, MutationTree } from 'vuex';
import { RootState } from '~/store';

export const skuKey = {
  namespace: 'sku'
};

export const state = () => ({
  sku: null,
  skus: [],
  page: null
});

export type SKUState = ReturnType<typeof state>;

export const getters: GetterTree<SKUState, RootState> = {
  getSku(state) {
    return state.sku;
  },
  getSkus(state) {
    return state.skus;
  }
};

export const mutations: MutationTree<SKUState> = {
  changeSKU: (state, sku) => (state.sku = sku),
  changeSKUS: (state, skus) => (state.skus = skus),
  changePage: (state, page) => (state.page = page)
};
